import { BdcDashboardGranularity } from "../../../types/bdcDashboard.type";

export const BDC_DASHBOARD_PATH = "/bdc/dashboard";
export const BDC_DASHBOARD_STORES_PATH = "/bdc/dashboard/stores";

/** Menu titles (children of the BDC group). */
export const BDC_DASHBOARD_MENU_TITLE = "ยอดสั่ง / ยอดส่ง";
export const BDC_DASHBOARD_STORES_MENU_TITLE = "ติดตามการสั่งของร้าน";

export const bdcDashboardStoresLink = (date?: string) =>
  date ? `${BDC_DASHBOARD_STORES_PATH}?date=${date}` : BDC_DASHBOARD_STORES_PATH;

export const GRANULARITY_OPTIONS: { value: BdcDashboardGranularity; label: string }[] = [
  { value: "day", label: "วัน" },
  { value: "week", label: "สัปดาห์" },
  { value: "month", label: "เดือน" },
];

/** Calendar days in each store's order calendar: four weeks, drawn Mon–Sun. */
export const STORE_CELLS = 28;
export const STORE_PAGE_SIZES = [10, 25, 50, 100];

/** Two series, validated as a pair (CVD ΔE 23, contrast ≥ 3:1 on white). */
export const CHART_COLORS = {
  ordered: "#2F6DB5",
  delivered: "#C46A12",
  /** Histogram: buckets below the lapse threshold, then at / past it. */
  shortLapse: "#9DBCE0",
  lapsed: "#1F4E85",
  /** Order calendar: ordered / not ordered (file existed) / not ordered since the last order / no file. */
  cellOrdered: "#2F6DB5",
  cellMissed: "#E6E7EB",
  cellLapsed: "#E3922B",
  cellNoFile: "#FFFFFF",
  grid: "#EEEFF2",
  axis: "#C9CBD2",
  ink: "#5A5F6B",
  track: "#EEEFF2",
} as const;

export const WARN_TILE = { bg: "#FFF4E3", border: "#F1D9AE", ink: "#6B4A10" } as const;
